























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapState(['parliament', 'parties']),
        ...mapGetters(['seats']),
    },
})
export default class SeatChart extends Vue {}
